<template>
  <div>
    <breadcrumb :breadcrumb_link="regBreadcrumb" />
    <div class="header">
      <h1 class="overlay">RESERVATION</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <ReceiptStage1 :list-type="listType" :rev-confirm-list="revConfirmList" v-if="stage === 1" />
      <ReceiptStage2 :list-type="listType" :rev-confirm-list="revConfirmList" v-if="stage === 2" />
      <ReceiptStage3 :list-type="listType" :rev-confirm-list="revConfirmList" v-if="stage === 3" />
      <ReceiptStage4 :list-type="listType" :rev-confirm-list="revConfirmList" v-if="stage === 4" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import moment from 'moment';

import ReceiptStage1 from '@/pages/RevReceiptPage/Component/ReceiptStage1';
import ReceiptStage2 from '@/pages/RevReceiptPage/Component/ReceiptStage2';
import ReceiptStage3 from '@/pages/RevReceiptPage/Component/ReceiptStage3';
import ReceiptStage4 from '@/pages/RevReceiptPage/Component/ReceiptStage4';
import {ReceiptViewModel} from '@/pages/RevReceiptPage/Model/receiptModel';
import {getReservText, isGolfReservEnter} from '@/util/GolfUtil';
import GeneralUtil from '@/util/GeneralUtil';
import {PINX_TOKEN} from '@/util/Const';

export default {
  name: 'RegPage2',
  props: {
    listType: String,
  },
  mixins: [GeneralUtil],
  components: {
    Breadcrumb,
    ReceiptStage1,
    ReceiptStage2,
    ReceiptStage3,
    ReceiptStage4,
  },
  watch: {
    listType(oldVal, newVal) {
      this.stage = 1;
      this.revConfirmList = [];
      this.removedMultiTeamItem = [];
      if (this.listType === 'RECEIPT') {
        this.$store.dispatch('Display/changeName', {name: '사전접수'});
      } else if (this.listType === 'WAIT') {
        this.$store.dispatch('Display/changeName', {name: '잔여접수'});
      }
    },
    selectedMember(newValue, oldValue) {
      if (newValue && newValue !== oldValue && !this.isAutoLogout) {
        this.showMsgBoxConfirm('고객 구분이 변경되어 예약이 초기화 됩니다.').then(x => {
          //예약이 가능한 회원들은 처음부터 진행, 그 외는 전부 메인으로 쫓아낸다.
          if (
            (this.listType === 'RECEIPT' || this.listType === 'WAIT') &&
            isGolfReservEnter(newValue.memType, newValue.guestType)
          ) {
            this.$router.go(0);
          } else {
            this.$router.replace('/');
          }
        });
      }
    },
  },
  computed: {
    selectedMember() {
      return this.$store.getters['Auth/selectedMember'];
    },
    reservText() {
      return getReservText(this.listType);
    },
    regBreadcrumb() {
      return {
        toplink: 'HOME',
        prevlink: 'GOLF COURSE',
        present: this.reservText,
      };
    },
  },
  data() {
    return {
      stage: 1,
      revConfirmList: [],
      removedMultiTeamItem: [],
      isAutoLogout: false,
    };
  },
  created() {
    this.$EventBus.$on('AddReceipt', this.AddReceipt);
    this.$EventBus.$on('RemoveReceipt', this.RemoveReceipt);
    this.$EventBus.$on('NextStage', this.NextStage);
    this.$EventBus.$on('PrevStage', this.PrevStage);
    this.$EventBus.$on('GoFirstStage', this.GoFirstStage);
    this.$EventBus.$on('GoRootPage', this.GoRootPage);

    this.$EventBus.$on('SetAllReceiptDetail', this.SetAllReceiptDetail);
  },
  beforeDestroy() {
    this.$EventBus.$off('AddReceipt', this.AddReceipt);
    this.$EventBus.$off('RemoveReceipt', this.RemoveReceipt);
    this.$EventBus.$off('NextStage', this.NextStage);
    this.$EventBus.$off('PrevStage', this.PrevStage);
    this.$EventBus.$off('GoFirstStage', this.GoFirstStage);
    this.$EventBus.$off('GoRootPage', this.GoRootPage);

    this.$EventBus.$off('SetAllReceiptDetail', this.SetAllReceiptDetail);

    window.removeEventListener('storage', this.onStorageUpdate);
  },
  mounted() {
    console.log('모바일 헤더', this.listType);
    if (this.listType === 'RECEIPT') {
      this.$store.dispatch('Display/changeName', {name: '사전접수'});
    } else if (this.listType === 'WAIT') {
      this.$store.dispatch('Display/changeName', {name: '잔여접수'});
    }

    window.addEventListener('storage', this.onStorageUpdate);
  },
  methods: {
    onStorageUpdate(event) {
      //예약페이지는 따로 처리
      if (this.$route.path.indexOf('Preregistration') > 0 || this.$route.path.indexOf('Waitingreception') > 0) {
        if (event.key === PINX_TOKEN && event.newValue === '') {
          this.isAutoLogout = true;
          console.log('Logged out from another tab!');
          this.$store.dispatch('Auth/signOut', '');
          // do whatever you need after logout
          this.showMsgBoxOk(
            this.htmlToVNode('다른 브라우저에서 로그아웃 되었습니다.<br/> 정보가 변경 되어 예약이 초기화 됩니다.'),
          ).then(() => this.$router.replace('/'));
        } else if (event.key === PINX_TOKEN && event.oldValue === '' && event.newValue !== '') {
          console.log('login from another tab!');
          this.$store.dispatch('Auth/initLogin');
        }
      }
    },
    NextStage() {
      if (this.stage < 4) {
        this.stage++;

        if (this.stage == 2) {
          this.seperateMultiTeam();
        }
      }
    },
    PrevStage() {
      if (this.stage > 1) {
        this.stage--;

        if (this.stage === 1) {
          this.mergeMultiTeam();
          this.revConfirmList = [];
          this.removedMultiTeamItem = [];
        }
      }
    },

    GoFirstStage() {
      this.stage = 1;
    },
    GoRootPage() {
      this.$router.replace('/');
    },

    /***
     * Stage1 Methods
     * @param revinfo
     * @constructor
     */

    seperateMultiTeam() {
      let multiTeam = [];
      this.revConfirmList.forEach(x => {
        if (x.teamCount > 1) {
          multiTeam.push(x);
        }
      });

      // remove multiTeam
      multiTeam.forEach(x => {
        this.RemoveReceipt(x);
        this.removedMultiTeamItem.push(x);
      });

      // add seperateTeam
      multiTeam.forEach(x => {
        for (let i = 0; i < x.teamCount; i++) {
          let data = new ReceiptViewModel();
          data.selectedDate = x.selectedDate;
          data.selectedCourse = x.selectedCourse;
          data.selectedTeeOff = x.selectedTeeOff;
          data.teamIndex = i + 1;
          data.teamCount = 1;
          data.teamLimitCount = this.limitCount;
          data.teamReservCount = this.reservCount;

          data.receiptDetail.bookName = x.receiptDetail.bookName;
          data.receiptDetail.memNo = x.receiptDetail.memNo;
          data.receiptDetail.hpNo = x.receiptDetail.hpNo;

          console.log('*****', data, x);

          this.AddReceipt(data);
        }
      });
    },

    mergeMultiTeam() {
      let targetItems = [];
      this.removedMultiTeamItem.forEach(x => {
        this.revConfirmList.forEach(y => {
          if (x.Compare(y)) {
            targetItems.push(x);
          }
        });
      });

      // remove SEPERATE ITEMS
      targetItems.forEach(x => {
        this.RemoveReceipt(x);
      });
      // ADD ORIGIN ITEM
      this.removedMultiTeamItem.forEach(x => {
        this.AddReceipt(x);
      });
      this.removedMultiTeamItem = [];
    },

    AddReceipt(revinfo) {
      this.revConfirmList.push(revinfo);

      this.revConfirmList = this.revConfirmList.sort((a, b) => {
        if (a.selectedDate === b.selectedDate) {
          if (this.listType === 'REAL') {
            if (a.selectedRealTeeOff.time === b.selectedRealTeeOff.time) {
              return a.teamIndex > b.teamIndex ? 1 : -1;
            } else {
              return a.selectedRealTeeOff.time > b.selectedRealTeeOff.time ? 1 : -1;
            }
          } else {
            if (a.selectedTeeOff.detailName === b.selectedTeeOff.detailName) {
              return a.teamIndex > b.teamIndex ? 1 : -1;
            } else {
              return a.selectedTeeOff.detailName > b.selectedTeeOff.detailName ? 1 : -1;
            }
          }
        }
        return a.selectedDate > b.selectedDate ? 1 : -1;
      });

      this.$EventBus.$emit('UpdateDot');
    },

    RemoveReceipt(item) {
      let targetIndex = this.revConfirmList.findIndex(x => {
        return x.Compare(item);
      });

      if (targetIndex > -1) {
        this.revConfirmList.splice(targetIndex, 1);
      }
      this.$EventBus.$emit('UpdateDot');
    },

    async SetAllReceiptDetail(s) {
      for (const t of this.revConfirmList) {
        //추천인 접수일경우 - 일자별 추천가능정보가 다를경우 경고창 띄우고 return
        // console.log('####');
        // console.log(s._bookedBy);
        // console.log(t.receiptDetail._recomValidYn);
        if (s._bookedBy === 'Recommender' && t.receiptDetail._recomValidYn === 'N') {
          const message =
            '본인 및 배우자만 예약이 가능한 금토일 주말이 포함되어 있어<br>추천인의 필수정보 일괄 입력이 어렵습니다.<br>추천 예약 시에는 월~목 일정만 선택되어야 일괄입력 가능합니다.<br>또한, 내장자 별로 예약을 분리하여 접수 부탁드립니다.';
          const res = await this.showMsgBoxOk(this.htmlToVNode(message), '필수정보 일괄입력 불가 안내');
          return;
        }
        t.SetReceiptDetail(s);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/Golf/header-login.jpg');
}

.header {
  position: relative;
  width: 100%;

  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }
  .container {
    padding-top: 5rem;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
